import FilterForm from "../components/FilterForm";
import Layout from "../components/Layout/Layout";
import LoginContainer from "./LoginContainer";
const Filter = () => {
  const user = JSON.parse(window.localStorage.getItem("user"));
  if (user) {
    return (
      <Layout user={user}>
        <FilterForm user={user} />
      </Layout>
    );
  } else {
    return <LoginContainer />;
  }
};
export default Filter;